import HomeIcon from '../../../../icons/home-light.svg'
import PrivateIcon from '../../../../icons/lock.svg'
import UsersIcon from '../../../../icons/users-1.svg'

export const PRIVATE_ACCOUNT = 'private'

export const PUBLIC_ACCOUNT = 'public'

export const SYSTEM_ACCOUNT = 'system'

export const ACCOUNT_ICONS = {
  [PRIVATE_ACCOUNT]: PrivateIcon,
  [PUBLIC_ACCOUNT]: UsersIcon,
  [SYSTEM_ACCOUNT]: HomeIcon,
}

export const ACCOUNT_TYPE_TOOLTIP_KEY = {
  [PRIVATE_ACCOUNT]: 'Email.PrivateTooltipKey',
  [PUBLIC_ACCOUNT]: 'Email.PublicTooltipKey',
  [SYSTEM_ACCOUNT]: 'Email.SystemTooltipKey',
}
